import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import StockIndicesFull from './stock-indices-full'

const StockIndicesFullWidget = (props) => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <StockIndicesFull {...props} />
    </QueryClientProvider>
  );
};

export { StockIndicesFullWidget }
